import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './assets/translations/en';
import es from './assets/translations/es';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: { translation: { ...en } },
    es: { translation: { ...es } },
  },
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  returnEmptyString: false, // Return fallback language instead of empty strings
});

export default i18n;
